var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GekkoButton',{staticClass:"mt-2",attrs:{"text":_vm.$gettext('Undo downgrade'),"icon":"fa-solid fa-rotate-left"},on:{"click":function($event){return _vm.undoDowngrade()}}})}
var staticRenderFns = []

export { render, staticRenderFns }